export const POLYGON_FILE_ACCEPT = '.kml,.geojson,.json,.zip';
export const MAX_POLYGON_FILE_SIZE_MB = 10;

const ALLOWED_EXTENSIONS = POLYGON_FILE_ACCEPT.split(',');

const validatePolygonFile = file => {
  if (!file) return null;

  const name = (file.name || '').toLowerCase();
  const hasAllowedExtension = ALLOWED_EXTENSIONS.some(ext => name.endsWith(ext));
  if (!hasAllowedExtension) {
    return 'Formato no admitido. Sube un archivo de polígono en formato KML, GeoJSON o shapefile (.zip).';
  }

  if (file.size > MAX_POLYGON_FILE_SIZE_MB * 1024 * 1024) {
    return `El archivo de polígono excede el tamaño máximo de ${MAX_POLYGON_FILE_SIZE_MB} MB.`;
  }

  return null;
};

export default validatePolygonFile;
